const mapReturnConfirmation = (returnData)=>{
    var ref1;
    return {
        status: returnData.status,
        returnLabelUrl: returnData.returnLabelUrl,
        returnInfo: ((ref1 = returnData.order.returnInfo) === null || ref1 === void 0 ? void 0 : ref1.map((info)=>{
            return {
                orderNumber: returnData.order.orderNumber,
                items: info.items.map((item)=>{
                    var ref;
                    const lineItem = item.lineItem;
                    if (!lineItem.product) {
                        console.log(`Missing product information while requesting Returns line item for order ${returnData.order.orderNumber}`);
                        return {
                            comment: item.comment,
                            quantity: item.quantity,
                            lineItem: {
                                displayName: '',
                                imageSrc: '',
                                quantity: lineItem.quantity,
                                sku: lineItem.sku,
                                lineItemNumber: lineItem.lineItemNumber
                            }
                        };
                    }
                    const { product  } = lineItem;
                    return {
                        comment: item.comment,
                        quantity: item.quantity,
                        lineItem: {
                            displayName: product.displayName,
                            imageSrc: product.media.images.length ? (ref = product.media.images[0]) === null || ref === void 0 ? void 0 : ref.url : undefined,
                            quantity: lineItem.quantity,
                            sku: product.sku,
                            lineItemNumber: lineItem.lineItemNumber
                        }
                    };
                }),
                returnDate: info.returnDate,
                returnTrackingId: info.returnTrackingId
            };
        })) || []
    };
};

export { mapReturnConfirmation };
//# sourceMappingURL=map-return-confirmation.js.map
